/**
 * ══════════════════════════════════════════════════════════════════════════
 * GÖNDERİ EYLEM ŞERİDİ — TEK SUNUM BİLEŞENİ
 * ══════════════════════════════════════════════════════════════════════════
 *
 * ── NİYE VAR (owner, 2026-09-13) ─────────────────────────────────────────
 * *"Bu turda aynı ekranları bağımsız düzenlemeyi bırak … Önce PostMobile.tsx
 * içindeki aksiyon düzenini ayır. ProfilePostViewerMobile.tsx aynı bileşeni
 * kullansın."*
 *
 * ÖLÇÜLEN KUSUR (kaynak kodundan, 2026-09-13): aynı dört eylem iki ekranda
 * İKİ BAĞIMSIZ KARAR KAYNAĞIYLA çiziliyordu —
 *   `PostMobile.tsx`               → `boyut="md"` (24 px)
 *   `ProfilePostViewerMobile.tsx`  → `size={28}` / `boyutPropsu(28)`
 * Yani "aynı görev, aynı ölçü" kuralı kodda hiçbir yerde YAZILI DEĞİLDİ;
 * bir ekran düzeltilirken öteki eski ölçüde kalıyordu. Bu bileşen o kararı
 * TEK yere taşır: sıra, hücre yapısı ve ikon ölçüsü buradadır.
 *
 * ── SORUMLULUK SINIRI ────────────────────────────────────────────────────
 * YALNIZ görünüm ve yerleşim. Puanlama/kaydetme/yorum/paylaşma işleyicileri
 * prop olarak GELİR; burada yeni veri aboneliği, servis çağrısı veya puan
 * hesabı YOKTUR (owner şartı). Yıldız tetiği de dışarıdan `yildiz` olarak
 * verilir: `contentId`/`authorId`/`disabled` gibi alanlar yüzeye göre değişir
 * ve bu bileşenin bilmesi gereken şeyler değildir.
 *
 * ── SINIF ÖNEKİ NİYE VAR ─────────────────────────────────────────────────
 * `onek` ile her yüzey kendi mevcut sınıflarını (`pm-*` / `ppv-*`) üretmeye
 * devam eder. Sebep ölçülü: bu iki ekranın CSS'i konumlandırma/dolgu
 * bakımından farklı (biri akış kartı, öteki tam-ekran izleyici) ve o
 * stiller ile onlara bağlı kapılar (`.pm-actions`, `.ppv-btn`
 * seçicileriyle ölçen süitler) yaşıyor. Ortaklaşan şey KARAR — sıra,
 * hücreler, ikon ölçüsü — deri değil. Sınıf adlarını da tek elden üretmek
 * ayrı bir turun işi; bu turda sınıf adı değiştirmek kapıları körletirdi.
 */
import React from "react";
import { IkonKoprusu } from "../../icon-system/runtime/IkonKoprusu";
// Erişilebilir adda TAM sayı; görünen yuvada kısa biçim (tek kaynak).
import { formatCount as sayacTam, formatCompact } from "../../myclipsv3/design/formatNumber";
import "./PostActionsBar.css";

/** Aksiyon ikonlarının ORTAK ölçüsü — KULLANIM_SOZLESMESI §2.1 "A — aksiyon"
 *  (24 px, `--ikon-kullanim-aksiyon`). İki ekranın 24/28 ayrımı buraya
 *  düştü; yüzeyler artık kendi sayısını yazmaz. */
export const AKSIYON_BOYUT = "md" as const;

export interface PostActionsBarProps {
  /** Yüzey: akış kartı (mobil/masaüstü), profil görüntüleyici, klip kartı. */
  onek: "pm" | "ppv" | "postDk" | "clipDk";
  /** Yıldız tetiği — yüzeye özgü props'larla dışarıda kurulur. */
  yildiz: React.ReactNode;
  onYorum?: () => void;
  yorumAdet?: number;
  onPaylas?: () => void;
  paylasAdet?: number;
  onKaydet?: () => void;
  kaydedildi?: boolean;
  /** Kaydetme sayacı — yalnız profil görüntüleyicisinde VAR; akış kartı bu
   *  sayıyı hiç taşımaz ve prop'u GEÇMEZ.
   *
   *  ⚠️ "verilmedi" ile "0" AYRI hâllerdir ve ayrımı yuvanın kaderi belirler:
   *   · prop verilmişse (0 olsa bile) yuva DURUR → 0→1 geçişinde kayma yok.
   *   · prop hiç verilmemişse o yüzeyde bu sayaç YOKTUR → yuva da çizilmez.
   *  Ölçülen kusur (2026-09-14, 390 px): varsayılan `= 0` yüzünden akış
   *  kartında hiç dolmayacak bir yuva ayrılıyordu; kaydet ikonu sağ kenardan
   *  ~43 px içeri kaçıyor, arkasında kalıcı boş şerit kalıyordu (bayrak
   *  KAPALIYKEN de görünen bir değişiklik). */
  kaydetAdet?: number;
  /** Eski `eski=` kanadı: bayrak KAPALI kolda çizilecek düğümler. */
  eskiYorum?: React.ReactNode;
  eskiPaylas?: React.ReactNode;
  eskiKaydet?: React.ReactNode;
  /** Sayaç biçimleyici (yüzeyler aynı `formatCount`u geçirir). */
  sayiBicimle?: (n: number) => React.ReactNode;
}

export default function PostActionsBar({
  onek,
  yildiz,
  onYorum,
  yorumAdet = 0,
  onPaylas,
  paylasAdet = 0,
  onKaydet,
  kaydedildi = false,
  kaydetAdet,          // ← varsayılan YOK: "verilmedi" bilgisi korunsun
  eskiYorum,
  eskiPaylas,
  eskiKaydet,
  sayiBicimle = formatCompact,
}: PostActionsBarProps) {
  /* ── SINIF ADLARI TAMAMEN LİTERAL (2026-09-14, iki kapı ölçerek öğretti) ──
     Her düğüm İKİ sınıf taşır: geometriyi veren ortak `pab-*` ve yüzeyin
     kendi `pm-*`/`ppv-*` adı (renk/zemin + mevcut kapıların seçicileri).
     İlk yazımda bu birleşim ÇALIŞMA ANINDA kuruluyordu
     (`` `pab-${ad} ${onek}-${ad}` ``) ve iki ayrı kapı buna takıldı:
       · `dokunma:kapi` hiçbir sınıf adını çözemeyip üç düğmeyi "tepki yok"
         saydı (borç 0 → 3),
       · `tembel:kapi` şablondan çıplak `actions` / `num` parçalarını okuyup
         onları TEMBEL css'lerdeki aynı adlı sınıflarla eşleştirdi
         (`.actions` → StoryModalMobile.css, `.num` → ig-mobile.css)
         ve iki sahte sızıntı bildirdi (23 → 25).
     İkisinde de ÜRÜNDE kusur yoktu; kusur, güvencenin ÖLÇÜLEMEZ olmasıydı.
     🧭 Ders: statik analizle yaşayan bir depoda sınıf adını çalışma anında
     kurmak, o adı bütün kapılardan gizler. Tablo hem ürünü hem ölçüyü
     doğru kılar; tek kaynak yine tek yerde (aşağıda). */
  /* ── DÖRT YÜZEY, TEK KARAR (owner, 2026-09-14) ─────────────────────────
     *"`Post.tsx` ve `ClipInFeed.tsx` bu bileşene bağlı değil."* — doğruydu.
     Masaüstü ve klip kartı yapı olarak MOBİLDEN FARKLI: hücre sarmalayıcısı
     ve sayaç YOK, ikon sınıfı düğmeden AYRI. Bu fark uydurma değil, bugünkü
     ürünün gerçeği; DOM'u zorla eşitlemek o iki yüzeyin CSS'ini ve onlara
     bağlı kapıları kırardı.
     Bu yüzden yüzey tablosu DOM farkını da taşır (`hucre`, `ikonSinif`):
     ORTAKLAŞAN ŞEY KARAR — eylem SIRASI (puan → yorum → paylaş | kaydet),
     ikon ÖLÇÜSÜ (A = 24) ve dokunma tabanı. Deri yüzeyde kalır. */
  const SINIFLAR = {
    pm: {
      actions: "pab-actions pm-actions",
      actionsLeft: "pab-actions-left pm-actions-left",
      act: "pab-act pm-act",
      btn: "pab-btn pm-btn",
      num: "pab-num pm-num",
    },
    ppv: {
      actions: "pab-actions ppv-actions",
      actionsLeft: "pab-actions-left ppv-actions-left",
      act: "pab-act ppv-act",
      btn: "pab-btn ppv-btn",
      num: "pab-num ppv-num",
    },
    /* MASAÜSTÜ AKIŞ — hücre yok, sayaç yok, ikonun kendi sınıfı var.
       ⚠️ `kaydetEk: " save"` ZORUNLU ve ÖLÇÜLEREK eklendi (2026-09-14).
       Eski markup kaydet düğmesine ayrı bir `save` sınıfı veriyordu ve
       `Post.css:197` o sınıfa `margin-left: auto` bağlıyor. Ortak bileşene
       geçerken sınıf DÜŞTÜ → kural ölü kaldı → boşluğu emen auto marj
       kalkınca `.pab-actions`ın `justify-content: space-between`i DÖRT
       eylemi kart genişliğine YAYDI. Ölçüldü (1440×900, bayrak KAPALI):
         önce  621 / 663 / 705 / 1019   (üçlü solda gruplu, IG deseni)
         sonra 629 / 756 / 884 / 1011   (üçlü kart boyunca dağılmış)
       Klip kartı aynı kusura düşmedi, çünkü onun eki (`clipDk-save`)
       veriliyordu — yani kusur bir SINIF EKSİKLİĞİYDİ, tasarım değil.
       🧭 Bu, bayrak KAPALIYKEN de görünen bir yerleşim değişikliğiydi:
       «DOM aynı» ile «görünüm aynı» ayrı şeylerdir. */
    postDk: {
      actions: "pab-actions postDk-actions",
      actionsLeft: "",
      act: "postDk-starWrap",
      btn: "postDk-actionBtn",
      num: "postDk-num",
      ikonSinif: "postDk-actionIcon",
      kaydetEk: " save",
      hucre: false,
    },
    /* KLİP KARTI — aynı yapı; kaydet düğmesi ek `clipDk-save` sınıfı taşır. */
    clipDk: {
      actions: "pab-actions clipDk-actions",
      actionsLeft: "",
      act: "clipDk-rateWrap",
      btn: "clipDk-actionBtn",
      num: "clipDk-num",
      ikonSinif: "clipDk-icon",
      kaydetEk: " clipDk-save",
      hucre: false,
    },
  } as const;
  const c = SINIFLAR[onek] as {
    actions: string; actionsLeft: string; act: string; btn: string; num: string;
    ikonSinif?: string; kaydetEk?: string; hucre?: boolean;
  };
  const hucreli = c.hucre !== false;
  const ikonSinif = c.ikonSinif;

  /* ── ERİŞİLEBİLİR AD: TAM SAYI (owner, 2026-09-14) ──────────────────────
     *"Tam sayı erişilebilir adında korunsun."* Görünen metin KISALTILMIŞ
     ("1,2 Mn") çünkü yuva sabit; ama ekran okuyucu tam değeri duymalı.
     Bu yüzden sayı düğmenin `aria-label`ına TAM biçimde girer ve görünen
     yuva `aria-hidden` olur — aksi hâlde aynı sayı iki kez okunurdu
     (bir kez tam, bir kez "bir virgül iki Mn" diye). */
  const ad = (temel: string, adet?: number) =>
    (adet && adet > 0 ? `${temel}, ${sayacTam(adet)}` : temel);

  return (
    <div className={c.actions}>
      {/* SOL GRUP — hücreli yüzeylerde ayrı bir kap (mobil ritim), masaüstü ve
          klip şeridinde kapsız: bugünkü DOM'ları böyle. */}
      {hucreli ? (
        <div className={c.actionsLeft}>
          <div className={c.act}>{yildiz}</div>
          <div className={c.act}>
            <button className={`${c.btn} pressable`} onClick={onYorum} aria-label={ad("Yorumlar", yorumAdet)}>
              <IkonKoprusu aile="content.comment" varyant="outline" boyut={AKSIYON_BOYUT} className={ikonSinif} eski={eskiYorum} />
            </button>
              {/* YUVA BOŞKEN DE DURUR (owner, 2026-09-14): `{n > 0 && …}` idi ve
                0 → 1 geçişinde öğe DOĞDUĞU için yerleşim kayıyordu; `6ch` tek
                başına bunu engellemiyordu. Artık yuva hep var, 0'da metin boş. */}
            <span className={c.num} aria-hidden="true">{yorumAdet > 0 ? sayiBicimle(yorumAdet) : ""}</span>
          </div>
          <div className={c.act}>
            <button className={`${c.btn} pressable`} onClick={onPaylas} aria-label={ad("Paylaş", paylasAdet)}>
              <IkonKoprusu aile="content.share" varyant="outline" boyut={AKSIYON_BOYUT} className={ikonSinif} eski={eskiPaylas} />
            </button>
              <span className={c.num} aria-hidden="true">{paylasAdet > 0 ? sayiBicimle(paylasAdet) : ""}</span>
          </div>
        </div>
      ) : (
        <>
          <div className={c.act}>{yildiz}</div>
          <button className={`${c.btn} pressable`} onClick={onYorum} aria-label="Yorumlar">
            <IkonKoprusu aile="content.comment" varyant="outline" boyut={AKSIYON_BOYUT} className={ikonSinif} eski={eskiYorum} />
          </button>
          <button className={`${c.btn} pressable`} onClick={onPaylas} aria-label="Paylaş">
            <IkonKoprusu aile="content.share" varyant="outline" boyut={AKSIYON_BOYUT} className={ikonSinif} eski={eskiPaylas} />
          </button>
        </>
      )}

      {/* KAYDET — sağda sabit hücre; puan/sayaç uzasa da yeri değişmez. */}
      {hucreli ? (
        <div className={c.act}>
          <button
            className={`${c.btn} pressable`}
            onClick={onKaydet}
            aria-label={ad(kaydedildi ? "Kaydedildi" : "Kaydet", kaydetAdet)}
          >
            <IkonKoprusu
              aile="content.save"
              varyant={kaydedildi ? "selected" : "outline"}
              boyut={AKSIYON_BOYUT}
              className={ikonSinif}
              eski={eskiKaydet}
            />
          </button>
          {/* Yuva YALNIZ bu yüzey sayacı taşıyorsa ayrılır; taşıyorsa değer 0
              olsa bile DURUR (bkz. `kaydetAdet` prop açıklaması). */}
          {kaydetAdet !== undefined && (
            <span className={c.num} aria-hidden="true">{kaydetAdet > 0 ? sayiBicimle(kaydetAdet) : ""}</span>
          )}
        </div>
      ) : (
        <button
          className={`${c.btn}${c.kaydetEk || ""} pressable`}
          onClick={onKaydet}
          aria-label={kaydedildi ? "Kaydedildi" : "Kaydet"}
        >
          <IkonKoprusu
            aile="content.save"
            varyant={kaydedildi ? "selected" : "outline"}
            boyut={AKSIYON_BOYUT}
            className={ikonSinif}
            eski={eskiKaydet}
          />
        </button>
      )}
    </div>
  );
}
